import React, {Component} from 'react';

import './RemedialTrainingResponse.scss';
import CustomForm from "../../../../shared/components/form/CustomForm";
import {validateRequired} from "../../../../shared/components/form/ValidationFunctions";
import classNames from "classnames";

class RemedialTrainingResponse extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFormOpened: false
    }

  }

  get value() {
    return this.props.value && this.props.value.list || []
  }

  get isEdit() {
    return this.props.isEdit !== false
  }

  componentDidMount() {
    this.props.onValueChange && this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: true,
    });
  }

  get formConfig() {
    return {
      fields: {
        name: {
          type: 'text',
          label: this.props.element.name_label,
          rules: [validateRequired(this.props.element.name_label)]
        },
        hours_spend: {
          type: 'time',
          label: this.props.element.hours_spend_label,
          rules: [validateRequired(this.props.element.hours_spend_label)]
        },
        reason: {
          type: 'textarea',
          label: this.props.element.reason_label,
          rules: [validateRequired(this.props.element.reason_label)]
        },
        successful: {
          type: 'boolean',
          label: this.props.element.remedial_training_successful_label,
          // rules: [validateRequired( this.props.element.remedial_training_successful_label)]
        },
        recap: {
          type: 'textarea',
          label: this.props.element.recap_of_results_label
        },
        continue: {
          type: 'boolean',
          label: this.props.element.continue_remedial_training_label,
          // rules: [validateRequired( this.props.element.continue_remedial_training_label)]
        }
      }
    }
  }

  openForm() {
    this.setState({
      isFormOpened: true
    })
  }

  onAddLog(log) {
    this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: true,
      list: [...this.value, log]
    });
    this.setState({
      isFormOpened: false
    })
  }

  removeItem(index) {
    let copyVal = [...this.value];
    copyVal.splice(index, 1);
    this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: !!copyVal.length,
      list: copyVal
    })
  }

  render() {
    return (
      <div className={classNames({"remedial-training-response": true, 'preview': !this.isEdit})}>
        <div className="remedial-training-title">
          {this.props.element.title_label}
        </div>
        {this.value.map((val, index) => (
          <div className="remedial-training-response-item" key={val.name}>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.name_label}
              </div>
              <div className="rt-value">
                {val.name}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.hours_spend_label}
              </div>
              <div className="rt-value">
                {val.hours_spend}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.reason_label}
              </div>
              <div className="rt-value">
                {val.reason}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.remedial_training_successful_label}
              </div>
              <div className="rt-value">
                {val.successful ? 'YES' : 'NO'}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.recap_of_results_label}
              </div>
              <div className="rt-value">
                {val.recap}
              </div>

            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.continue_remedial_training_label}
              </div>
              <div className="rt-value">
                {val.continue ? 'YES' : 'NO'}
              </div>
            </div>
            {this.isEdit && (
              <div className="rt-item">
                <button className="button danger small" type="button" onClick={() => this.removeItem(index)}>
                  <i className="fa fa-trash"/> Delete log
                </button>
              </div>
            )}
          </div>
        ))}
        {
          !this.state.isFormOpened && this.isEdit && (
            <div className="text-right add-rt">
              <button className="button primary small" type="button" onClick={() => this.openForm()}>
                <i className="fa fa-plus"/> Add remedial training record
              </button>
            </div>
          )
        }

        {this.state.isFormOpened && (
          <div>
            <CustomForm
              config={this.formConfig}
              saveLabel={'Add'}
              saveIcon={'fa fa-plus'}
              onSubmit={(log) => this.onAddLog(log)}
            />
          </div>
        )}
      </div>
    )
  }
}

export default RemedialTrainingResponse;
